import { render, staticRenderFns } from "./edit-address-modal.vue?vue&type=template&id=34aeb9ee&scoped=true"
import script from "./edit-address-modal.vue?vue&type=script&lang=js"
export * from "./edit-address-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-address-modal.vue?vue&type=style&index=0&id=34aeb9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aeb9ee",
  null
  
)

export default component.exports